import React from 'react';
import Header from '../Header/Header';
import ServicesSection from '../Services/ServicesSection';
import CubeInteractif from '../CubeInteractif/CubeInteractif';

// Header Component
const Home = () => (
  <>
    {/* <div style={{ height: "100vh", margin: 0 }}>
      <CubeInteractif />
    </div> */}
    <Header/>
    <ServicesSection variant="homepage"/>
  </>
);

export default Home;